import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class OnboardingScreenService {

    constructor(
        private http: HttpClient
    ) { }

    signUp(signUpObj) {
        return this.http.post(environment.serverUrl + '/team/selfonboard',  signUpObj);
    }

    verifyTeamName(teamName) {
        return this.http.get(environment.serverUrl + '/team/verify/' +  teamName);
    }
    
    verifyEmailId(emailId) {
        return this.http.get(environment.serverUrl + '/team/selfonboard/verifyUser/' +  emailId);
    }
}



// WEBPACK FOOTER //
// ./src/app/onboarding-screen/onboarding-screen.service.ts